import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private readonly translate = inject(TranslateService);

  constructor() {
    this.translate.setFallbackLang('en').subscribe();
  }

  setLanguage(lang: string): void {
    this.translate.use(lang).subscribe();
  }
}
